export default "__VITE_ASSET__B1XwRi4a__"